export type FeatureFlagRule = {
  treatment: string
  segments: string[]
  ids: number[]
}

export type FeatureFlagTag = {
  label: string
  color: string | null
  timestamp: string
}

export type FeatureFlag = {
  id: string
  treatments: string[]
  defaultTreatment: string
  trafficType: string
  rules: FeatureFlagRule[]
  tags: FeatureFlagTag[]
  lastClientVersion: string | null
  lastUsedAt: string | null
}

export type FeatureFlagSaveInput = {
  treatments: string[]
  defaultTreatment: string
  trafficType: string
  rules: FeatureFlagRule[]
  tags: FeatureFlagTagSaveInput[]
}

export type FeatureFlagTagSaveInput = {
  label: string
  color: string | null
}

export type Segment = {
  id: string
  name: string
  tenantIds: number[]
}

export type SegmentSaveInput = {
  name: string
  tenantIds: number[]
}

export const TRAFFIC_TYPE_TENANT = 'tenant'

export const defaultFeatureFlag = (): FeatureFlag => ({
  id: '',
  treatments: ['on', 'off'],
  defaultTreatment: 'off',
  trafficType: TRAFFIC_TYPE_TENANT,
  rules: [],
  tags: [],
  lastClientVersion: null,
  lastUsedAt: null,
})

const ruleMatches = (rule: FeatureFlagRule, tenantId: number, mySegments: string[]): boolean => {
  if (rule.ids.includes(tenantId)) {
    return true
  }
  return rule.segments.some((segment) => mySegments.includes(segment))
}

export const evaluateTreatment = (
  features: FeatureFlag[],
  flagId: string,
  tenantId: number,
  mySegments: string[],
  fallbackTreatment: string
): string => {
  const flag = features.find((feature) => feature.id === flagId)
  if (!flag) {
    return fallbackTreatment
  }
  const matchingRule = flag.rules.find((rule) => ruleMatches(rule, tenantId, mySegments))
  if (matchingRule) {
    return matchingRule.treatment
  }
  return flag.defaultTreatment
}

export const isTreatmentOn = (treatment: string): boolean => {
  return treatment.toLowerCase() === 'on'
}

export const evaluateFeatureFlag = (
  features: FeatureFlag[],
  flagId: string,
  tenantId: number,
  mySegments: string[],
  defaultValue: boolean
): boolean => {
  const treatment = evaluateTreatment(features, flagId, tenantId, mySegments, 'control')
  if (isTreatmentOn(treatment)) {
    return true
  }
  return defaultValue
}
